import { CbhFeatureFlag, useCbhFlag } from "@src/appV2/FeatureFlags";

export function useShowZeroScoreLogs() {
  const value = useCbhFlag(CbhFeatureFlag.CLIPBOARD_SCORE_REDESIGN, {
    defaultValue: { enabled: false },
  });

  return value.enabled && Boolean(value.scoreLogs);
}
